import React from 'react';

const Hero = () => {
  return (
    <section id="home" className="min-h-screen flex items-center justify-center relative px-4 py-20">
      <div className="container mx-auto">
        <div className="max-w-6xl mx-auto text-center">
          {/* Main Title */}
          <div className="mb-12 animate-fadeIn">
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold mb-6 font-heading leading-tight">
              <span className="text-white">Breaking the</span>
              <br />
              <span className="bg-gradient-to-r from-primary via-secondary to-accent bg-clip-text text-transparent">
                South Asian Matrix
              </span>
            </h1>
            <div className="h-1 w-32 bg-gradient-to-r from-primary to-secondary mx-auto rounded-full"></div>
          </div>

          {/* Tagline */}
          <p className="text-2xl md:text-3xl text-gray-300 mb-16 font-light leading-relaxed max-w-4xl mx-auto">
            How centuries of mental conditioning shaped our choices —<br className="hidden md:block" />
            and how our generation can finally break free
          </p>

          {/* Key Message Box */}
          <div className="bg-gradient-to-br from-dark/80 to-darker/80 backdrop-blur-sm border-2 border-primary/30 rounded-3xl p-10 md:p-14 mb-16 max-w-5xl mx-auto shadow-2xl">
            <div className="text-left space-y-6">
              <p className="text-xl md:text-2xl text-gray-200 leading-relaxed">
                From the moment a child is born in this region, they're placed inside a <span className="text-warning font-semibold">small nutshell</span> — a world built by their parents, relatives, and society.
              </p>
              <p className="text-xl md:text-2xl text-gray-200 leading-relaxed">
                They're told what to study, what to believe, and even what dreams are <span className="text-danger font-semibold">"acceptable."</span>
              </p>
              <p className="text-xl md:text-2xl text-primary font-semibold leading-relaxed">
                By the time they grow up, most of them don't even realize — they've never lived a single day by their own choice.
              </p>
            </div>
          </div>

          {/* CTA */}
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-16">
            <a href="#the-matrix">
              <button className="bg-gradient-to-r from-primary to-secondary text-white px-10 py-4 rounded-full font-bold text-lg hover:shadow-2xl hover:shadow-primary/50 transition-all duration-300 transform hover:scale-105 font-heading">
                Understand The Matrix
              </button>
            </a>
            <a href="#break-free">
              <button className="border-2 border-accent text-accent px-10 py-4 rounded-full font-bold text-lg hover:bg-accent hover:text-white transition-all duration-300 transform hover:scale-105 font-heading">
                How To Break Free
              </button>
            </a>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="bg-dark/50 backdrop-blur-sm rounded-2xl p-6 border border-primary/20">
              <div className="text-4xl font-bold text-primary mb-2">2+ Billion</div>
              <div className="text-gray-400">People Affected</div>
            </div>
            <div className="bg-dark/50 backdrop-blur-sm rounded-2xl p-6 border border-secondary/20">
              <div className="text-4xl font-bold text-secondary mb-2">Centuries</div>
              <div className="text-gray-400">Of Conditioning</div>
            </div>
            <div className="bg-dark/50 backdrop-blur-sm rounded-2xl p-6 border border-accent/20">
              <div className="text-4xl font-bold text-accent mb-2">Gen Z</div>
              <div className="text-gray-400">Leading The Change</div>
            </div>
          </div>

          {/* Scroll Indicator */}
          <div className="mt-20 animate-bounce">
            <svg className="w-8 h-8 text-primary mx-auto" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
              <path d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
            </svg>
            <p className="text-gray-500 mt-2 text-sm">Scroll to explore</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;